import type { SVGProps } from "react"

const IDBack = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 350 350" {...props}>
    <circle data-name="Ellipse 4687" cx={175} cy={175} r={175} fill="#fff" />
    <rect
      data-name="Rectangle 1493"
      width={242.626}
      height={161.751}
      rx={9.732}
      transform="translate(48.713 88.625)"
      fill="#fff"
    />
    <path
      data-name="Path 40157"
      d="M278.5 252.355H61.558a14.841 14.841 0 01-14.825-14.823V101.469a14.841 14.841 0 0114.825-14.823H278.5a14.839 14.839 0 0114.823 14.823v136.063a14.839 14.839 0 01-14.823 14.823zM61.558 90.605a10.876 10.876 0 00-10.865 10.864v136.063A10.876 10.876 0 0061.558 248.4H278.5a10.876 10.876 0 0010.864-10.864V101.469A10.876 10.876 0 00278.5 90.605z"
      fill="#1d1d1b"
    />
    <rect
      data-name="Rectangle 1494"
      width={85.827}
      height={9.403}
      rx={4.701}
      transform="translate(78.172 108.497)"
      fill="#c6c6c5"
    />
    <rect
      data-name="Rectangle 1495"
      width={204.996}
      height={9.403}
      rx={4.701}
      transform="translate(66.75 207.302)"
      fill="#c6c6c5"
    />
    <rect
      data-name="Rectangle 1496"
      width={204.996}
      height={9.403}
      rx={4.701}
      transform="translate(66.75 191.496)"
      fill="#c6c6c5"
    />
    <rect
      data-name="Rectangle 1497"
      width={47.015}
      height={9.403}
      rx={4.701}
      transform="rotate(-90 208.673 -53.161)"
      fill="currentColor"
    />
    <rect
      data-name="Rectangle 1498"
      width={85.827}
      height={9.403}
      rx={4.701}
      transform="translate(78.172 127.303)"
      fill="#c6c6c5"
    />
    <rect
      data-name="Rectangle 1499"
      width={85.827}
      height={9.403}
      rx={4.701}
      transform="translate(78.172 146.109)"
      fill="#c6c6c5"
    />
    <rect
      data-name="Rectangle 1500"
      width={203.83}
      height={9.403}
      rx={4.701}
      transform="translate(67.332 223.422)"
      fill="#c6c6c5"
    />
    <path data-name="Path 40158" d="M66.944 268.961a1.7 1.7 0 101.7 1.7 1.7 1.7 0 00-1.7-1.7z" fill="#1d1d1b" />
    <path data-name="Path 40159" d="M80.556 268.961a1.7 1.7 0 101.7 1.7 1.7 1.7 0 00-1.7-1.7z" fill="#1d1d1b" />
    <circle
      data-name="Ellipse 4688"
      cx={1.702}
      cy={1.702}
      r={1.702}
      transform="translate(92.467 268.961)"
      fill="#1d1d1b"
    />
    <path data-name="Path 40160" d="M107.781 268.961a1.7 1.7 0 101.7 1.7 1.7 1.7 0 00-1.7-1.7z" fill="#1d1d1b" />
    <path data-name="Path 40161" d="M53.332 255.349a1.7 1.7 0 101.7 1.7 1.7 1.7 0 00-1.7-1.7z" fill="#1d1d1b" />
    <path data-name="Path 40162" d="M66.944 255.349a1.7 1.7 0 101.7 1.7 1.7 1.7 0 00-1.7-1.7z" fill="#1d1d1b" />
    <path data-name="Path 40163" d="M80.556 255.349a1.7 1.7 0 101.7 1.7 1.7 1.7 0 00-1.7-1.7z" fill="#1d1d1b" />
    <path data-name="Path 40164" d="M94.169 255.349a1.7 1.7 0 101.7 1.7 1.7 1.7 0 00-1.7-1.7z" fill="#1d1d1b" />
    <path data-name="Path 40165" d="M107.781 255.349a1.7 1.7 0 101.7 1.7 1.7 1.7 0 00-1.7-1.7z" fill="#1d1d1b" />
    <circle
      data-name="Ellipse 4689"
      cx={1.702}
      cy={1.702}
      r={1.702}
      transform="translate(119.692 268.961)"
      fill="#1d1d1b"
    />
    <path data-name="Path 40166" d="M135.006 268.961a1.7 1.7 0 101.7 1.7 1.7 1.7 0 00-1.7-1.7z" fill="#1d1d1b" />
    <circle
      data-name="Ellipse 4690"
      cx={1.702}
      cy={1.702}
      r={1.702}
      transform="translate(146.917 268.961)"
      fill="#1d1d1b"
    />
    <path data-name="Path 40167" d="M162.231 268.961a1.7 1.7 0 101.7 1.7 1.7 1.7 0 00-1.7-1.7z" fill="#1d1d1b" />
    <path data-name="Path 40168" d="M175.844 268.961a1.7 1.7 0 101.7 1.7 1.7 1.7 0 00-1.7-1.7z" fill="#1d1d1b" />
    <path data-name="Path 40169" d="M121.394 255.349a1.7 1.7 0 101.7 1.7 1.7 1.7 0 00-1.7-1.7z" fill="#1d1d1b" />
    <path data-name="Path 40170" d="M135.006 255.349a1.7 1.7 0 101.7 1.7 1.7 1.7 0 00-1.7-1.7z" fill="#1d1d1b" />
    <path data-name="Path 40171" d="M148.619 255.349a1.7 1.7 0 101.7 1.7 1.7 1.7 0 00-1.7-1.7z" fill="#1d1d1b" />
    <path data-name="Path 40172" d="M162.231 255.349a1.7 1.7 0 101.7 1.7 1.7 1.7 0 00-1.7-1.7z" fill="#1d1d1b" />
    <path data-name="Path 40173" d="M175.844 255.349a1.7 1.7 0 101.7 1.7 1.7 1.7 0 00-1.7-1.7z" fill="#1d1d1b" />
    <path data-name="Path 40174" d="M189.456 268.961a1.7 1.7 0 101.7 1.7 1.7 1.7 0 00-1.7-1.7z" fill="#1d1d1b" />
    <circle
      data-name="Ellipse 4691"
      cx={1.702}
      cy={1.702}
      r={1.702}
      transform="translate(201.367 268.961)"
      fill="#1d1d1b"
    />
    <path data-name="Path 40175" d="M216.681 268.961a1.7 1.7 0 101.7 1.7 1.7 1.7 0 00-1.7-1.7z" fill="#1d1d1b" />
    <path data-name="Path 40176" d="M230.294 268.961a1.7 1.7 0 101.7 1.7 1.7 1.7 0 00-1.7-1.7z" fill="#1d1d1b" />
    <path data-name="Path 40177" d="M243.906 268.961a1.7 1.7 0 101.7 1.7 1.7 1.7 0 00-1.7-1.7z" fill="#1d1d1b" />
    <path data-name="Path 40178" d="M189.456 255.349a1.7 1.7 0 101.7 1.7 1.7 1.7 0 00-1.7-1.7z" fill="#1d1d1b" />
    <path data-name="Path 40179" d="M203.069 255.349a1.7 1.7 0 101.7 1.7 1.7 1.7 0 00-1.7-1.7z" fill="#1d1d1b" />
    <path data-name="Path 40180" d="M216.681 255.349a1.7 1.7 0 101.7 1.7 1.7 1.7 0 00-1.7-1.7z" fill="#1d1d1b" />
    <path data-name="Path 40181" d="M230.294 255.349a1.7 1.7 0 101.7 1.7 1.7 1.7 0 00-1.7-1.7z" fill="#1d1d1b" />
    <path data-name="Path 40182" d="M243.906 255.349a1.7 1.7 0 101.7 1.7 1.7 1.7 0 00-1.7-1.7z" fill="#1d1d1b" />
    <path data-name="Path 40183" d="M257.518 268.961a1.7 1.7 0 101.7 1.7 1.7 1.7 0 00-1.7-1.7z" fill="#1d1d1b" />
    <path data-name="Path 40184" d="M271.131 268.961a1.7 1.7 0 101.7 1.7 1.7 1.7 0 00-1.7-1.7z" fill="#1d1d1b" />
    <path data-name="Path 40185" d="M284.743 268.961a1.7 1.7 0 101.7 1.7 1.7 1.7 0 00-1.7-1.7z" fill="#1d1d1b" />
    <path data-name="Path 40186" d="M298.356 268.961a1.7 1.7 0 101.7 1.7 1.7 1.7 0 00-1.7-1.7z" fill="#1d1d1b" />
    <path data-name="Path 40187" d="M257.518 255.349a1.7 1.7 0 101.7 1.7 1.7 1.7 0 00-1.7-1.7z" fill="#1d1d1b" />
    <path data-name="Path 40188" d="M271.131 255.349a1.7 1.7 0 101.7 1.7 1.7 1.7 0 00-1.7-1.7z" fill="#1d1d1b" />
    <path data-name="Path 40189" d="M284.743 255.349a1.7 1.7 0 101.7 1.7 1.7 1.7 0 00-1.7-1.7z" fill="#1d1d1b" />
    <path data-name="Path 40190" d="M298.356 255.349a1.7 1.7 0 101.7 1.7 1.7 1.7 0 00-1.7-1.7z" fill="#1d1d1b" />
    <path data-name="Path 40191" d="M311.968 255.349a1.7 1.7 0 101.7 1.7 1.7 1.7 0 00-1.7-1.7z" fill="#1d1d1b" />
    <path data-name="Path 40192" d="M298.356 241.736a1.7 1.7 0 101.7 1.7 1.7 1.7 0 00-1.7-1.7z" fill="#1d1d1b" />
    <path data-name="Path 40193" d="M311.968 241.736a1.7 1.7 0 101.7 1.7 1.7 1.7 0 00-1.7-1.7z" fill="#1d1d1b" />
    <path data-name="Path 40194" d="M298.356 228.124a1.7 1.7 0 101.7 1.7 1.7 1.7 0 00-1.7-1.7z" fill="#1d1d1b" />
    <path data-name="Path 40195" d="M311.968 228.124a1.7 1.7 0 101.7 1.7 1.7 1.7 0 00-1.7-1.7z" fill="#1d1d1b" />
    <path data-name="Path 40196" d="M298.356 214.511a1.7 1.7 0 101.7 1.7 1.7 1.7 0 00-1.7-1.7z" fill="#1d1d1b" />
    <path data-name="Path 40197" d="M298.356 200.9a1.7 1.7 0 101.7 1.7 1.7 1.7 0 00-1.7-1.7z" fill="#1d1d1b" />
    <path data-name="Path 40198" d="M311.968 214.511a1.7 1.7 0 101.7 1.7 1.7 1.7 0 00-1.7-1.7z" fill="#1d1d1b" />
    <path data-name="Path 40199" d="M311.968 200.9a1.7 1.7 0 101.7 1.7 1.7 1.7 0 00-1.7-1.7z" fill="#1d1d1b" />
    <path data-name="Path 40200" d="M298.356 187.286a1.7 1.7 0 101.7 1.7 1.7 1.7 0 00-1.7-1.7z" fill="#1d1d1b" />
    <path data-name="Path 40201" d="M311.968 187.286a1.7 1.7 0 101.7 1.7 1.7 1.7 0 00-1.7-1.7z" fill="#1d1d1b" />
    <path data-name="Path 40202" d="M298.356 173.674a1.7 1.7 0 101.7 1.7 1.7 1.7 0 00-1.7-1.7z" fill="#1d1d1b" />
    <path data-name="Path 40203" d="M311.968 173.674a1.7 1.7 0 101.7 1.7 1.7 1.7 0 00-1.7-1.7z" fill="#1d1d1b" />
    <path data-name="Path 40204" d="M298.356 160.061a1.7 1.7 0 101.7 1.7 1.7 1.7 0 00-1.7-1.7z" fill="#1d1d1b" />
    <path data-name="Path 40205" d="M311.968 160.061a1.7 1.7 0 101.7 1.7 1.7 1.7 0 00-1.7-1.7z" fill="#1d1d1b" />
    <path data-name="Path 40206" d="M298.356 146.449a1.7 1.7 0 101.7 1.7 1.7 1.7 0 00-1.7-1.7z" fill="#1d1d1b" />
    <path data-name="Path 40207" d="M298.356 132.836a1.7 1.7 0 101.7 1.7 1.7 1.7 0 00-1.7-1.7z" fill="#1d1d1b" />
    <path data-name="Path 40208" d="M311.968 146.449a1.7 1.7 0 101.7 1.7 1.7 1.7 0 00-1.7-1.7z" fill="#1d1d1b" />
    <path data-name="Path 40209" d="M311.968 132.836a1.7 1.7 0 101.7 1.7 1.7 1.7 0 00-1.7-1.7z" fill="#1d1d1b" />
    <path data-name="Path 40210" d="M298.356 119.224a1.7 1.7 0 101.7 1.7 1.7 1.7 0 00-1.7-1.7z" fill="#1d1d1b" />
    <path data-name="Path 40211" d="M311.968 119.224a1.7 1.7 0 101.7 1.7 1.7 1.7 0 00-1.7-1.7z" fill="#1d1d1b" />
    <path data-name="Path 40212" d="M298.356 105.611a1.7 1.7 0 101.7 1.7 1.7 1.7 0 00-1.7-1.7z" fill="#1d1d1b" />
    <path data-name="Path 40213" d="M311.968 105.611a1.7 1.7 0 101.7 1.7 1.7 1.7 0 00-1.7-1.7z" fill="#1d1d1b" />
    <path data-name="Path 40214" d="M298.356 92a1.7 1.7 0 101.7 1.7 1.7 1.7 0 00-1.7-1.7z" fill="#1d1d1b" />
  </svg>
)
export { IDBack }
